import { observable, action } from 'mobx';
import gql from 'graphql-tag';

const StartQuery = gql`
    query StartQuery {
        readToolPage {
            ID
            Title
            StartTitle
            StartContent
        }
    }
`;

export class StartStore {
    appStore;

    @observable page = [];

    @observable loading = true;

    @action reset() {
        this.page = [];
    }

    constructor(opts) {
        this.appStore = opts.appStore;
    }

    async initializeContent() {
        if (typeof window.HTContent !== typeof undefined) {
            this.page = window.HTContent;
            this.loading = false;
            return;
        }

        this.loading = true;
        const result = await this.appStore.apolloClient
            .query({
                query: StartQuery,
                fetchPolicy: 'network-only'
            })
            .catch(result => {
                const errors = result.graphQLErrors.map(error => error.message);
                this.error = {
                    message: errors.join(', '),
                    code: 500
                };
                this.loading = false;
            });

        if (
            result &&
            result.data.readToolPage &&
            result.data.readToolPage.length > 0
        ) {
            this.page = result.data.readToolPage[0];
            this.loading = false;
        } else {
            this.page = false;
            this.loading = false;
        }
    }
}
